export default function registerScriptAttacher(className: string, attacher: (element: HTMLElement) => void) {
    document.addEventListener('DOMContentLoaded', () => {
        for (const element of document.body.querySelectorAll<HTMLElement>(`.${className}`)) {
            attacher(element);
        }
        new MutationObserver(mutations => {
            for (const mutation of mutations) {
                for (const addedNode of mutation.addedNodes) {
                    if (addedNode instanceof Element) {
                        if (addedNode instanceof HTMLElement && addedNode.classList.contains(className)) {
                            attacher(addedNode);
                        } else {
                            for (const element of addedNode.querySelectorAll<HTMLElement>(`.${className}`)) {
                                attacher(element);
                            }
                        }
                    }
                }
            }
        }).observe(document.body, {subtree: true, childList: true});
    });
}
